export const trueFitConfig = {
    getClientID(locale: string) {
        switch (locale) {
            // NB. We converted langs earlier to the following format - 'en-AU' to 'en_AU' - to satisfy the True Fit API
            // NB. 'en-UK' is a special case and has to become 'en_GB'
            case 'en_AU':
                return process.env.NEXT_PUBLIC_TRUEFIT_CLIENT_ID;
            case 'en_US':
                return process.env.NEXT_PUBLIC_TRUEFIT_CLIENT_ID_US;
            case 'en_EU':
                return process.env.NEXT_PUBLIC_TRUEFIT_CLIENT_ID_EU;
            case 'en_GB':
                return process.env.NEXT_PUBLIC_TRUEFIT_CLIENT_ID_UK;
            default:
                return process.env.NEXT_PUBLIC_TRUEFIT_CLIENT_ID;
        }
    },
    getAPIBaseURL(locale: string) {
        switch (locale) {
            // NB. We converted langs earlier to the following format - 'en-AU' to 'en_AU' - to satisfy the True Fit API
            // NB. 'en-UK' is a special case and has to become 'en_GB'
            case 'en_AU':
                return process.env.NEXT_PUBLIC_TRUEFIT_API_INSTANCE;
            case 'en_US':
                return process.env.NEXT_PUBLIC_TRUEFIT_API_INSTANCE_US;
            case 'en_EU':
                return process.env.NEXT_PUBLIC_TRUEFIT_API_INSTANCE_EU;
            case 'en_GB':
                return process.env.NEXT_PUBLIC_TRUEFIT_API_INSTANCE_UK;
            default:
                return process.env.NEXT_PUBLIC_TRUEFIT_API_INSTANCE;
        }
    },
    tokenEndpoint(locale: string) {
        const clientID = this.getClientID(locale);
        return `/profile/public/v3/${clientID}/token`;
    },
    fitRecommendationEndpoint(
        productID: string,
        locale: string,
        deviceType: string
    ) {
        const clientID = this.getClientID(locale);
        return `/consumer/public/v3/${clientID}/fit/tfc-fitrec-product?s=${productID}&locale=${locale}&deviceType=${deviceType}&platform=web`;
    },
};
